import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { HeroIconImage } from "./HXHistoryHeroIcon.styles";
import { HistoryCategory } from "./PatientHistory.types";
import emergencyIcon from "../Media/history-hero-icons/emergency-icon.svg";
import primaryCareIcon from "../Media/history-hero-icons/primary-care-icon.svg";
import specialistIcon from "../Media/history-hero-icons/specialist-icon.svg";
import urgentCareIcon from "../Media/history-hero-icons/urgent-care-icon.svg";
import physicalIcon from "../Media/history-hero-icons/physical-icon.svg";
import chiropracticIcon from "../Media/history-hero-icons/chiropractic-icon.svg";
import acupunctureIcon from "../Media/history-hero-icons/acupuncture-icon.svg";
import labDrawIcon from "../Media/history-hero-icons/lab-draw-icon.svg";
import imagingIcon from "../Media/history-hero-icons/imaging-icon.svg";
import biopsyIcon from "../Media/history-hero-icons/biopsy-icon.svg";
import colonoscopyIcon from "../Media/history-hero-icons/colonoscopy-icon.svg";
import infusionIcon from "../Media/history-hero-icons/infusion-icon.svg";
import procedureIcon from "../Media/history-hero-icons/procedure-icon.svg";
import surgeryIcon from "../Media/history-hero-icons/surgery-icon.svg";
import vaccinationIcon from "../Media/history-hero-icons/vaccination-icon.svg";
import geneticTestIcon from "../Media/history-hero-icons/genetic-test-icon.svg";
import sleepStudyIcon from "../Media/history-hero-icons/sleep-study-icon.svg";
import allergyTestingIcon from "../Media/history-hero-icons/allergy-testing-icon.svg";
import cardiacStressIcon from "../Media/history-hero-icons/cardiac-stress-icon.svg";
import pulmonaryFunctionIcon from "../Media/history-hero-icons/pulmonary-function-icon.svg";
import mentalHealthIcon from "../Media/history-hero-icons/mental-health-icon.svg";
import dentalIcon from "../Media/history-hero-icons/dental-icon.svg";
import visionIcon from "../Media/history-hero-icons/vision-icon.svg";
import obstetricsIcon from "../Media/history-hero-icons/obstetrics-icon.svg";
import { colors } from "healthex-common/colors";
const categoryConfig = {
    [HistoryCategory.EMERGENCY]: { icon: emergencyIcon, heroBgColor: colors.record_emergency_hero_bg },
    [HistoryCategory.PRIMARY_CARE]: { icon: primaryCareIcon, heroBgColor: colors.record_primary_care_hero_bg },
    [HistoryCategory.SPECIALIST]: { icon: specialistIcon, heroBgColor: colors.record_specialist_hero_bg },
    [HistoryCategory.URGENT_CARE]: { icon: urgentCareIcon, heroBgColor: colors.record_urgent_care_hero_bg },
    [HistoryCategory.ANNUAL_PHYSICAL]: { icon: physicalIcon, heroBgColor: colors.record_physical_hero_bg },
    [HistoryCategory.CHIROPRACTIC]: { icon: chiropracticIcon, heroBgColor: colors.record_chiropractic_hero_bg },
    [HistoryCategory.ACUPUNCTURE]: { icon: acupunctureIcon, heroBgColor: colors.record_acupuncture_hero_bg },
    [HistoryCategory.LAB_DRAW]: { icon: labDrawIcon, heroBgColor: colors.record_lab_draw_hero_bg },
    [HistoryCategory.IMAGING]: { icon: imagingIcon, heroBgColor: colors.record_imaging_hero_bg },
    [HistoryCategory.BIOPSY]: { icon: biopsyIcon, heroBgColor: colors.record_biopsy_hero_bg },
    [HistoryCategory.COLONOSCOPY]: { icon: colonoscopyIcon, heroBgColor: colors.record_colonoscopy_hero_bg },
    [HistoryCategory.INFUSION]: { icon: infusionIcon, heroBgColor: colors.record_infusion_hero_bg },
    [HistoryCategory.MINOR_PROCEDURE]: { icon: procedureIcon, heroBgColor: colors.record_procedure_hero_bg },
    [HistoryCategory.SURGERY]: { icon: surgeryIcon, heroBgColor: colors.record_surgery_hero_bg },
    [HistoryCategory.VACCINATION]: { icon: vaccinationIcon, heroBgColor: colors.record_vaccination_hero_bg },
    [HistoryCategory.GENETIC_TEST]: { icon: geneticTestIcon, heroBgColor: colors.record_genetic_test_hero_bg },
    [HistoryCategory.SLEEP_STUDY]: { icon: sleepStudyIcon, heroBgColor: colors.record_sleep_study_hero_bg },
    [HistoryCategory.ALLERGY_TESTING]: { icon: allergyTestingIcon, heroBgColor: colors.record_allergy_testing_hero_bg },
    [HistoryCategory.CARDIAC_STRESS_TEST]: { icon: cardiacStressIcon, heroBgColor: colors.record_cardiac_stress_hero_bg },
    [HistoryCategory.PULMONARY_FUNCTION_TEST]: { icon: pulmonaryFunctionIcon, heroBgColor: colors.record_pulmonary_function_hero_bg },
    [HistoryCategory.MENTAL_HEALTH]: { icon: mentalHealthIcon, heroBgColor: colors.record_mental_health_hero_bg },
    [HistoryCategory.DENTAL]: { icon: dentalIcon, heroBgColor: colors.record_dental_hero_bg },
    [HistoryCategory.VISION]: { icon: visionIcon, heroBgColor: colors.record_vision_hero_bg },
    [HistoryCategory.OBSTETRICS]: { icon: obstetricsIcon, heroBgColor: colors.record_obstetrics_hero_bg },
};
export const HXHistoryHeroIcon = ({ category }) => {
    const config = categoryConfig[category];
    return _jsx(HeroIconImage, { src: config.icon, alt: "" });
};
export function getHeroBgColor(category) {
    return categoryConfig[category].heroBgColor;
}
